import { FC } from 'react';
import Navbar from '../navbar';
import styles from './styles.module.css';

const Header: FC = () => (
  <div className={styles.wrapper}>
    <Navbar />
  </div>
);

export default Header;
